import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';

export const eventResources = {
  getApiEvents: createResourceBuilder('/admin/events', EResourceMethod.Get),
};
